import React, { useState, useEffect } from 'react';

import GenericInputContainer from '../shared/GenericInputContainer';
import DisplaySelectLabel from './DisplaySelectLabel';
import EditSelectLabel from './EditSelectLabel';

const SelectLabelInputContainer = ({ initialValue: onPageLoadValue, options, syncChanges, isEditing, setIsEditing, isHovered }) => {
    const [value, setValue] = useState(onPageLoadValue ? onPageLoadValue : null);
    const [initialValue, setInitialValue] = useState(onPageLoadValue ? onPageLoadValue : null);
    const isFieldNull = value === null;

    useEffect(() => {
        setValue(onPageLoadValue ? onPageLoadValue : null);
        setInitialValue(onPageLoadValue ? onPageLoadValue : null);
    }, [onPageLoadValue]);

    const valueHasntChanged = () => {
        if (value === null || initialValue === null) {
            return value === initialValue;
        }
        return value.id === initialValue.id;
    };

    const handleSave = async () => {
        const response = await syncChanges(value);
        if (response.success) {
            setInitialValue(value);
        }
        return response;
    };

    const handleCancel = () => {
        setValue(initialValue);
        setIsEditing(false);
    };

    return (
        <GenericInputContainer {...{ isEditing, setIsEditing, isHovered, isFieldNull, handleSave, handleCancel, valueHasntChanged }}>
            <DisplaySelectLabel {...{ value }} />
            <EditSelectLabel {...{ value, setValue, options, handleCancel }} />
        </GenericInputContainer>
    );
};

export default SelectLabelInputContainer;
